import 'vite/modulepreload-polyfill';
import 'styles/tailwind.css';

import React from 'react';

import { createRoot } from 'react-dom/client';

import { initErrorTracking } from 'helpers/tracking/ErrorTracking';

import App from './appWrapper';
import UpdatedApp from './update/AppWrapper';

initErrorTracking(['Login']);

const useNewLogin = localStorage.getItem('useNewLogin') === 'true';
const Root = useNewLogin ? UpdatedApp : App;

const toggleLoginVersion = () => {
    localStorage.setItem('useNewLogin', useNewLogin ? 'false' : 'true');
    window.location.reload();
};

// Desktop: Ctrl+ø to toggle login version
window.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.key === 'ø') {
        toggleLoginVersion();
    }
});

// Mobile: Tap the SalesScreen logo 5 times rapidly to toggle
let tapCount = 0;
let tapTimer: ReturnType<typeof setTimeout>;
document.addEventListener(
    'click',
    (e) => {
        const target = e.target as HTMLElement;
        if (target.tagName === 'IMG' && target.getAttribute('alt')?.startsWith('SalesScreen')) {
            tapCount++;
            clearTimeout(tapTimer);
            tapTimer = setTimeout(() => {
                tapCount = 0;
            }, 2000);
            if (tapCount >= 5) {
                tapCount = 0;
                toggleLoginVersion();
            }
        }
    },
    true,
);

const container = document.getElementById('loginComponentWrapper');
if (container) {
    createRoot(container).render(<Root />);
}
